export default {
  categories: [],
  pagination: {},
  category: {}
}
